export const BREAKPOINT_EXTRA_SMALL = 640;
export const BREAKPOINT_SMALL = 768;
export const BREAKPOINT_MEDIUM = 1024;

export const LEFTBAR_MIN_WIDTH = 200;
export const LEFTBAR_MAX_WIDTH = 400;

export const MIN_TASK_DETAIL_WIDTH = 200;
export const MIN_CHAT_PANEL_WIDTH = 200;
export const MIN_MAIN_CONTENT_WIDTH = 400;
export const MIN_TASK_LIST_AND_DETAIL_WIDTH = MIN_TASK_DETAIL_WIDTH + MIN_MAIN_CONTENT_WIDTH;
